<p-table [totalRecords]="documentSummaryInfos?.length" #dt [value]="documentSummaryInfos" styleClass="p-datatable-striped p-datatable-responsive-eca"
         [scrollable]="!isOnMobile &&    documentSummaryInfos?.length > 5" scrollHeight="500px"
         [globalFilterFields]="['documentType', 'originalFilename']" [responsive]="true" [columns]="columns">
  <ng-container *ngIf="showTableCaption">

    <ng-template pTemplate="caption">
      <div class="table-header">
        <div class="view eca-primary-bg" style="min-height: 65px; color: white">
          <div class="as-of-date-container">
            <div class="container-fluid">
              <div class="row">
                <div class="col-3">
                  <div class="as-of-date-container1" style="height: 100%">
                    <h3>
                      <span style="margin-left: 15px;">
                        <fa-icon [icon]="['fad', 'books']"> </fa-icon> Our Documents
                      </span>
                    </h3>
                  </div>
                </div>
                <div class="col">
                  <div class="float-right">
                    <div class="as-of-date-container" style="margin-top: 5px; margin-right: 5px">
                      <app-eca-checkbox [label]="'Include Expired?'" [(value)]="expiredFilter.includeExpired" (valueChange)="expiredFilterChanged()" ></app-eca-checkbox>
                      <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                               (input)="dt.filterGlobal($event.target.value, 'contains')"
                               placeholder="Search All" style="height: 90%" />
                      </span>

                      <app-eca-ghost-btn btnIcon="file-excel" btnText="Export" btnType="primary"></app-eca-ghost-btn>

                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 5rem;" pSortableColumn="entityType">
        Owner
        <p-sortIcon field="entityType"></p-sortIcon>
      </th>
      <th style="width: 3rem;" pSortableColumn="entityType">
        Type
        <p-sortIcon field="entityType"></p-sortIcon>
      </th>
      <th style="width: 6rem;" pSortableColumn="documentType">
        Document Type
        <p-sortIcon field="documentType"></p-sortIcon>
      </th>
      <th style="width: 6rem;" pSortableColumn="originalFilename">
        Original Filename
        <p-sortIcon field="originalFilename"></p-sortIcon>
      </th>
      <th style="width: 3rem;" pSortableColumn="documentCreationDate.dateTime">
        Created On
        <p-sortIcon field="documentCreationDate.dateTime"></p-sortIcon>
      </th>
      <th style="width: 3rem;" pSortableColumn="expiryDate.dateTime">
        Expires On
        <p-sortIcon field="expiryDate.dateTime"></p-sortIcon>
      </th>
      <th style="width: 3rem;" pSortableColumn="reviewDate.dateTime">
        Review Due On
        <p-sortIcon field="reviewDate.dateTime"></p-sortIcon>
      </th>
      <th style="width: 3rem;" pSortableColumn="totalObservations">
        Num. Obs.
        <p-sortIcon field="totalObservations"></p-sortIcon>
      </th>


      <th style="font-weight: bold; width: 3rem;"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-companyDocument let-columns="columns" style="margin: 15px;">
    <tr>
      <td *ngFor="let col of columns">
        <span class="p-column-title">{{col.header}}: </span>
        <label *ngIf="col.type=== 'owner'">
          <span *ngIf=" companyDocument.entityType === documentEntityType.company">
            {{companyDocument.companyName}}
          </span>
          <span *ngIf="companyDocument.entityType === documentEntityType.employedPerson">
            <a [routerLink]="'/operative/' + companyDocument.operativeId">{{companyDocument.operativeFullName}}</a>
          </span>
          <span *ngIf="companyDocument.entityType === documentEntityType.trainingRecord">
            <a [routerLink]="'/training-record/' + companyDocument.trainingRecordId">{{companyDocument.operativeFullName}}</a>
          </span>
          <span *ngIf="companyDocument.entityType === documentEntityType.trainingCourse">
            {{companyDocument.companyName}}
          </span>
        </label>
        <div>
          <span *ngIf="col.type=== 'text'">
            {{companyDocument[col.field]}}
          </span>
          <span *ngIf="col.type === 'date'">
            {{companyDocument[col.field]?.dateTime | date:'dd/MM/yyyy'}}
          </span>
          <span *ngIf="col.type === 'type'">
            {{documentEntityTypeString[ companyDocument[col.field]]}}
          </span>
        </div>
        <label *ngIf="col.type=== 'int'" style="margin-left: 49%;">
          <span>
            {{companyDocument[col.field]}}
          </span>
        </label>
      </td>
      <td>
        <div class="text-center">
          <app-eca-row-menu (viewBtnClicked)="viewCompanyDocumentClicked(companyDocument)"
                            [rowMenuItems]="rowMenuItems"
                            [contextItem]="companyDocument">
          </app-eca-row-menu>
        </div>
      </td>
    </tr>

  </ng-template>
</p-table>
